import { PlusIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Plus = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <PlusIcon size={Sizes[size]} color={stroke || fill} {...rest} />;
};

Plus.displayName = 'Plus';
